module.exports = __webpack_public_path__ + "img/upcoming-events_mls-all-star.db8937a4.jpg";